import React from 'react';
import styled from '@emotion/styled';
import { HeadingText30 } from '@modernhealth/vital-components';

interface Props {
    title: string;
}

export const WellbeingReportHeader: React.FC<Props> = ({ title }) => {
    return (
        <Container>
            <HeadingText30 marginBottom={8} marginTop={40}>
                {title}
            </HeadingText30>
        </Container>
    );
};

const Container = styled.div({
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
});
